import { hotjar } from 'react-hotjar';

const HOTJAR_NUMBER_ID = Number(import.meta.env.HOTJAR_ID);
const HOTJAR_VERSION = Number(import.meta.env.HOTJAR_VERSION);

export const initHotjar = () => {
    HOTJAR_NUMBER_ID && hotjar.initialize({ id: HOTJAR_NUMBER_ID, sv: HOTJAR_VERSION });
};
